import { gql } from "@apollo/client";

const GET_STATEMENT_OF_WORK = gql`
  query GetStatementOfWork($onboarding_token: String!) {
    statementOfWork: statement_of_work(onboarding_token: $onboarding_token) {
      value
    }
  }
`;

export default GET_STATEMENT_OF_WORK;
